import gql from 'graphql-tag';
import { BOX_FRAGMENT } from './box';
import { CONTROL_PHOTO_FRAGMENT } from './controlPhoto';

export const DELIVERY_FRAGMENT = gql`
    fragment DeliveryFragment on Delivery {
        _id
        deliveryDate
        isDynamic
        deliveryPersonUserId
        deliveryPerson {
            _id
            username
            profile {
                fullname
                firstname
                lastname
            }
        }
        label
        orders {
            number
        }
        organizationId
        organizationName
        roundColor
        roundName
        siteName
        siteId
        siteSetup {
            _id
        }
        state
        totem {
            address
            number
        }
        updatedAt
    }
`;

export const DELIVERY_WITH_BOXES_FRAGMENT = gql`
    fragment DeliveryWithBoxesFragment on Delivery {
        ...DeliveryFragment
        boxes {
            ...BoxFragment
        }
    }
    ${DELIVERY_FRAGMENT}
    ${BOX_FRAGMENT}
`;

export const UPDATE_STATE_RESULT_FRAGMENT = gql`
    fragment UpdateStateResultFragment on DeliveriesStateUpdateResult {
        updatedDeliveries {
            ...DeliveryFragment
            stateHistory {
                state
                createdAt
                createdByName
            }
            boxes {
                ...BoxFragment
            }
        }
        errors
    }
    ${DELIVERY_FRAGMENT}
    ${BOX_FRAGMENT}
`;

export const DELIVERY_PHOTOS_FRAGMENT = gql`
    fragment DeliveryPhotosFragment on Delivery {
        _id
        photos {
            type
            urls
        }
        controlPhotos {
            ...ControlPhotoFragment
        }
    }
    ${CONTROL_PHOTO_FRAGMENT}
`;
